import createTaskModule from '../utils/createTaskModule';
import type { DialogActions, InstanceStore } from './schema/TaskModuleInstances';

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createTaskModule called at module scope is not allowed. This may cause unwanted side effects. */
const dest = createTaskModule();
export const taskModuleActions: DialogActions = dest.actions;
export const taskModuleStore: InstanceStore = dest.store;
export const isDetailsDialogOpen = (): boolean => taskModuleStore().isOpen;
